/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {connect} from 'react-redux'
import Header from './Header'
import Content from './Content'
import NavigationItem from "../utils/classes/NavigationItem";
import {Routes} from "../utils/Routes";
import Fleets from "../fleets/Fleets";
import Assets from "../fleets/Assets";
import Faults from "../faults/list/Faults";
import FaultReport from "../faults/FaultReport";
import Dashboard from "../dashboard/Dashboard"
import Timer from '../common/Timer'
import { ResponsiveHelper } from '@scuf/common';
import {injectIntl} from "react-intl";
import {withRouter} from "react-router";
import {ACTIVITY_TYPES} from '../security/SecurityConst'
import {userHasActivity} from '../security/SecurityUtils'
import EngineHistory from "../assets/EngineHistory";
import Administration from "../admin/Administration";

class MainPage extends React.Component {
    constructor(props) {
        super(props)

        const {intl} = this.props

        this.state = {
            breakpoints: null,
            collapsedLeftMenu: true,
        };

        this.mainNavigation = [
            new NavigationItem().setName("Administration")
                .setOnClick(() => this.navigate(Routes.USERS))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.USERS))
                .publicField('component', Administration)
                .publicField('path', Routes.USERS)
                .publicField('access', [ACTIVITY_TYPES.CONFIG_READ]),

            new NavigationItem()
                .setName(intl.formatMessage({id:"page.dashboard"}))
                .setOnClick(() => this.navigate(Routes.DASHBOARD))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.DASHBOARD))
                .publicField('component', Dashboard)
                .publicField('path', Routes.DASHBOARD)
                .publicField('access', [ACTIVITY_TYPES.ALL_ISSUES_READ]),
            new NavigationItem()
                .setName(intl.formatMessage({id:"page.fleets"}))
                .setOnClick(() => this.navigate(Routes.FLEETS))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.FLEETS))
                .publicField('component', Fleets)
                .publicField('path', Routes.FLEETS)
                .publicField('access', [ACTIVITY_TYPES.FLEETS_READ]),
            new NavigationItem()
                .setName(intl.formatMessage({id:"page.assets"}))
                .setOnClick(() => this.navigate(Routes.ASSETS))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.ASSETS))
                .publicField('component', Assets)
                .publicField('path', Routes.ASSETS)
                .publicField('access', [ACTIVITY_TYPES.HDA_FUNCTIONALITIES, ACTIVITY_TYPES.ASSETS_READ]),
            new NavigationItem()
                .setName(intl.formatMessage({id: 'page.engineHistory'}))
                .setOnClick(() => this.navigate(Routes.ENGINE_HISTORY))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.ENGINE_HISTORY))
                .publicField('component', EngineHistory)
                .publicField('path', Routes.ENGINE_HISTORY)
                .publicField('access', [ACTIVITY_TYPES.HDA_FUNCTIONALITIES, ACTIVITY_TYPES.ASSETS_READ]),
            new NavigationItem()
                .setName(intl.formatMessage({id:"page.faults"}))
                .setOnClick(() => this.navigate(Routes.FAULTS))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.FAULTS))
                .publicField('component', Faults)
                .publicField('path', Routes.FAULTS)
                .publicField('access', [ACTIVITY_TYPES.ALL_ISSUES_READ]),
            new NavigationItem()
                .setName(intl.formatMessage({id: 'page.faultNew'}))
                .setOnClick(() => this.navigate(Routes.FAULT_NEW))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.FAULT_NEW))
                .publicField('iconRoot', 'building')
                .publicField('component', FaultReport)
                .publicField('path', Routes.FAULT_NEW)
                .publicField('access', [ACTIVITY_TYPES.ASSIGNED_ISSUES_WRITE]),
            new NavigationItem()
                .setName(intl.formatMessage({id:"page.dashboard"}))
                .setOnClick(() => this.navigate(Routes.DASHBOARD))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.DASHBOARD))
                .publicField('component', Dashboard)
                .publicField('path', Routes.DASHBOARD)
                .publicField('access', [ACTIVITY_TYPES.EXTERNAL_ACTIVITY]),
            new NavigationItem()
                .setName(intl.formatMessage({id: 'page.engineHistory'}))
                .setOnClick(() => this.navigate('/airtime'+Routes.ENGINE_HISTORY))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive('/airtime' + Routes.ENGINE_HISTORY))
                .publicField('component', EngineHistory)
                .publicField('path', Routes.ENGINE_HISTORY)
                .publicField('access', [ACTIVITY_TYPES.EXTERNAL_ACTIVITY]),
            new NavigationItem()
                .setName(intl.formatMessage({id:"page.faults"}))
                .setOnClick(() => this.navigate(Routes.FAULTS))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.FAULTS))
                .publicField('component', Faults)
                .publicField('path', Routes.FAULTS)
                .publicField('access', localStorage.getItem("sessionId") == null ? null : [ACTIVITY_TYPES.EXTERNAL_ACTIVITY]),
            new NavigationItem()
                .setName(intl.formatMessage({id: 'page.faultNew'}))
                .setOnClick(() => this.navigate(Routes.FAULT_NEW))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.FAULT_NEW))
                .publicField('iconRoot', 'building')
                .publicField('component', FaultReport)
                .publicField('path', Routes.FAULT_NEW)
                .publicField('access', localStorage.getItem("sessionId") == null ? null : [ACTIVITY_TYPES.EXTERNAL_ACTIVITY]),
            new NavigationItem()
                .setName(intl.formatMessage({id: "page.dashboard"}))
                .setOnClick(() => this.navigate(Routes.DASHBOARD))
                .publicField('public', false)
                .publicField('isActive', () => this.isActive(Routes.DASHBOARD))
                .publicField('component', Dashboard)
                .publicField('path', Routes.DASHBOARD)
                .publicField('access', [ACTIVITY_TYPES.UI_CONFIG_WRITE]),
        ]

        this.hasAccess = this.hasAccess.bind(this)
        this.navigate = this.navigate.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        // Ensure left menu is collapsed when the window width exceeds 991px (breakpoint m), i.e. desktopView is active
        if (prevState.breakpoints !== this.state.breakpoints && this.state.breakpoints && this.state.breakpoints.m
            && !this.state.collapsedLeftMenu) {
            this.setState({collapsedLeftMenu: true})
        }
    }

    isActive(route) {
        const {location} = this.props
        if (location.pathname === Routes.FAULT_NEW) {
            return location.pathname === route
        }
        // If location starting with '/assets
        if (location.pathname.indexOf(Routes.ASSETS) === 0) {
            // If location includes /faults it means we are on Fault Detail -> Fault Tab need to be highlighted
            if (location.pathname.includes(Routes.FAULTS)) {
                return route === Routes.FAULTS;
            }
            // If we are just on /assets it means we are on Asset Detail -> Fleets tab need to be highlighted
            if (route === Routes.FLEETS) {
                return true;
            }
            // In HDA environment, when clicking on Engines we're on '/asset' path
            return userHasActivity(this.props.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && route === Routes.ASSETS;

        }
        return location.pathname.indexOf(route) === 0
    }

    navigate(route) {
        const {history} = this.props
        this.setState({collapsedLeftMenu: true})
        history.push(route)
    }

    hasAccess(navigationItem) {
        let accessGranted = false
        let count = 0

        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)) {
            if (navigationItem.access == null || navigationItem.access.length === 0) {
                // If access restriction is not defined, external user must have it forbidden
            } else if (navigationItem.access.filter(a => a === ACTIVITY_TYPES.EXTERNAL_ACTIVITY).length === 0) {
                // if access is defined, external user has it forbidden if there is not EXTERNAL_ACTIVITY access included
            } else {
                accessGranted = true;
            }
        } else {
            if (navigationItem.access == null) {
                // If access restriction is not defined, external user need to have it forbidden
            } else if (navigationItem.access.length === 0) {
                accessGranted = true
            } else {
                navigationItem.access.forEach(a => {
                    if (userHasActivity(this.props.userProfile, a)) {
                        count++
                    }
                })

                if (count === navigationItem.access.length) {
                    accessGranted = true
                }
            }
        }

        // If user has HDA functionalities, Fleet management need to be hidden
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && navigationItem.path.includes('fleets')) {
            accessGranted = false
        }

        return accessGranted
    }

    render() {
        const desktopView = this.state.breakpoints && this.state.breakpoints.m
        const navItems = this.mainNavigation.filter(this.hasAccess)

        return (
            <React.Fragment>
                {this.state.breakpoints != null ?
                    <React.Fragment>
                        <Timer/>
                        <Header navItems={navItems.filter(item => item.path !== Routes.FAULT_NEW)}
                                leftMenu={!desktopView} navigate={this.navigate}
                                onMenuToggle={() => this.setState({collapsedLeftMenu: !this.state.collapsedLeftMenu})}/>
                        <Content navItems={navItems} collapsedLeftMenu={this.state.collapsedLeftMenu}/>
                    </React.Fragment>
                    :
                    null
                }
                <ResponsiveHelper
                    activeBreakPoints={(points) => this.setState({breakpoints: points})}
                />
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(MainPage)))
